export default {
    timer: null,
    start: null,

    close: function() {
        clearTimeout(this.timer)
        let toast = document.getElementById('toast')
        if(!toast) return false
        toast.remove()
    },

    startDismiss: function() {
        this.start = new Date().getTime()
        this.timer = setTimeout(this.close, 4000)
    },

    error: function(message) {
        this.close()
        let toast = document.createElement('div');
        toast.id = 'toast';
        toast.classList.add('toast')
        toast.classList.add('error')
        toast.addEventListener('click', this.close)
        toast.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z"/>
            </svg>
            <p>${message}</p>
        `;
        document.getElementsByTagName('main')[0].append(toast);
        this.startDismiss()
    },

    success: function(message) {
        this.close()
        let toast = document.createElement('div');
        toast.id = 'toast';
        toast.classList.add('toast')
        toast.addEventListener('click', this.close)
        toast.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <p>${message}</p>
        `;
        document.getElementsByTagName('main')[0].append(toast);
        this.startDismiss()
    }
}